<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<lcsj-filter :show-search="false" more-text="更多筛选" @search="inputChange()">
			<template #query>
				<el-button v-if="$checkBtnPermission('/customer/index', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
				<el-button v-if="$checkBtnPermission('/customer/index', 'reset')" size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
			</template>
			<template #actions><el-button v-if="$checkBtnPermission('/customer/index', 'create')" size="small" type="primary" class="el-icon-plus" @click="handleEdit()">新增</el-button></template>
			<el-form-item label="所属门店：">
					<el-select filterable v-model="formInline.belongStoreKeyId" placeholder="请选择门店" clearable size="small" @change="inputChange">
						<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="顾客类型：">
					<el-select v-model="formInline.customerType" placeholder="请选择顾客类型" filterable size="small" @change="inputChange">
						<el-option v-for="item in customerTypeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="档案编号：">
					<el-input clearable v-model="formInline.customerNo" size="small" placeholder="请输入档案编号" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="顾客姓名：">
					<el-input clearable v-model="formInline.name" size="small" placeholder="请输入顾客姓名" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="电话：">
					<el-input clearable v-model="formInline.phone" size="small" placeholder="请输入电话" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="进店类型：">
					<el-select v-model="formInline.inStoreType" placeholder="请选择进店类型" filterable size="small" @change="inputChange">
						<el-option v-for="item in inStoreTypeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="学校名称" prop="schoolName">
					<el-input clearable v-model="formInline.schoolName" size="small" placeholder="请输入学校名称" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="是否办卡：">
					<el-select v-model="formInline.hasVip" placeholder="请选择" clearable size="small" @change="inputChange">
						<el-option label="全部" :value="0"></el-option>
						<el-option label="是" :value="1"></el-option>
						<el-option label="否" :value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="是否创建提成：">
					<el-select v-model="formInline.hasCommission" placeholder="请选择" size="small" @change="inputChange">
						<el-option label="全部" :value="0"></el-option>
						<el-option label="是" :value="1"></el-option>
						<el-option label="否" :value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="提成时间：">
					<el-date-picker
						:value="formInline.grantTimeStart && formInline.grantTimeEnd ? [formInline.grantTimeStart, formInline.grantTimeEnd] : null"
						size="small"
						type="daterange"
						value-format="yyyy-MM-dd"
						range-separator="~"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						@input="setGrantTimeRange"
						@change="inputChange"
					></el-date-picker>
				</el-form-item>
			</lcsj-filter>
			<STable :columns="columnsData" :data="listData" :loading="loading" border height="520" @get-data="getListData" @handle-command="handleCommand" @row-db-click="handleRowClick">
				<template #name>
					<el-table-column align="center" label="顾客姓名" width="120">
						<template #default="scope">
							<el-link :underline="false" type="primary" @click="handleSelectOrderPage(scope.row)">
								{{ scope.row.name }}
							</el-link>
						</template>
					</el-table-column>
				</template>
				<template #gender>
					<el-table-column align="center" label="性别" width="80">
						<template #default="scope">
							<span v-if="scope.row.gender == 1" class="one_1">
								{{ formatterFre(scope.row.gender) }}
							</span>
							<span v-if="scope.row.gender == 0" class="one_2">
								{{ formatterFre(scope.row.gender) }}
							</span>
						</template>
					</el-table-column>
				</template>
				<template #isCreateVip>
					<el-table-column align="center" label="是否办卡" width="100">
						<template #default="scope">
<span v-if="scope.row.isCreateVip" class="yes-no yes-no--yes">是</span>
						<span v-else class="yes-no yes-no--no">否</span>
						</template>
					</el-table-column>
				</template>
				<!-- <el-table-column align="center" slot="isGrantCommission" label="是否创建提成" width="130">
		          <template slot-scope="scope">
		            <span v-if="scope.row.isGrantCommission" class="one_1">是</span>
		            <span v-else class="one_2">未发放</span>
		          </template>
		        </el-table-column> -->
				<template #operation>
					<el-table-column align="center" label="操作" min-width="220" fixed="right">
						<template #default="scope">
							<el-button
								v-if="btnPermissionList.commission && !scope.row.isGrantCommission && scope.row.inStoreType == 3"
								size="mini"
								type="primary"
								class="el-icon-edit"
								@click="handleCommissionClick(scope.row)"
							>
								提成
							</el-button>
						</template>
					</el-table-column>
				</template>
			</STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>
		<!-- 编辑 -->
		<edit ref="edit"></edit>
		<!-- 选择订单 -->
		<selectOrderPage ref="selectOrderPage"></selectOrderPage>
		<!-- 提成 -->
		<lcsj-dialog v-model="commissionShow" title="顾客提成" width="50%" cancel-text="关闭" confirm-text="确认"
			 custom-class="customer-commission-dialog"
			 :confirm-loading="isSubmitting" @confirm="handleGrantCommissionClick"> <span style="display: block; margin-bottom: 10px"><strong>提成类型:</strong></span>
			<el-radio-group v-model="commissionGrant.type" size="small">
				<el-radio :label="1" style="margin-right: 10px">跑单会员提成</el-radio>
				<el-radio :label="2" style="margin-right: 10px">进店成交提成</el-radio>
			</el-radio-group>
			<span style="display: block; margin-bottom: 10px"><strong>提成员工:</strong></span>
			<el-select v-model="commissionGrant.commissionUserKeyId" placeholder="请选择提成员工" filterable size="small" style="width: 100%">
				<el-option v-for="item in employeeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
			</el-select></lcsj-dialog>
	</div>
</template>

<script>
import { getCustomerInfoPageList, deleteCustomerInfo, GrantVipCommission } from "@/api/baseDataApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import { GetUserBindSelectByPermission } from "@/api/userApi.js";
import edit from "./edit";
import selectOrderPage from "./selectOrderPage.vue";
export default {
	data() {
		return {
		isSubmitting: false, // 提交中（防重复提交）
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "顾客列表"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			storeList: [],
			selectionList: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				name: "",
				phone: "",
				belongStoreKeyId: "",
				customerType: 0,
				customerNo: "",
				inStoreType: 0,
				schoolName: "",
				hasVip: 0,
				hasCommission: 0,
				grantTimeStart: null,
				grantTimeEnd: null
			},
			columnsData: [],
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					prop: "createTime",
					label: "创建时间",
					align: "center",
					width: "160",
				},
				{
					prop: "belongStoreName",
					label: "所属门店",
					align: "center",
					width: "80",
				},
				{
					slot: "name",
					label: "顾客姓名",
					align: "center",
					isKeep: true,
					minWidth: "120",
				},
				{
					prop: "age",
					label: "年龄",
					align: "center",
					width: "80"
				},
				{
					prop: "customerTypeStr",
					label: "会员类型",
					align: "center",
					isKeep: true,
					minWidth: "120"
				},
				{
					prop: "customerNo",
					label: "档案编号",
					align: "center",
					isKeep: true,
					minWidth: "120"
				},
				{
					prop: "inStoreTypeStr",
					label: "进店类型",
					align: "center",
					width: "120"
				},
				{
					prop: "phone",
					label: "联系电话",
					align: "center",
					width: "120"
				},
				{
					slot: "gender",
					label: "性别",
					align: "center",
					width: "80"
				},
				{
					slot: "isCreateVip",
					label: "是否办卡",
					align: "center",
					width: "100",
					isKeep: true
				},
				{
					prop: "processOrderCount",
					label: "加工订单数量",
					align: "center",
					width: "120"
				},
				{
					prop: "salesOrderCount",
					label: "销售订单数量",
					align: "center",
					width: "120"
				},
				{
					prop: "schoolName",
					label: "学校名称",
					align: "center",
					width: "120"
				},
				{
					prop: "grantUserName",
					label: "创建提成人",
					align: "center",
					width: "90"
				},
				{
					prop: "grantTime",
					label: "创建提成时间",
					align: "center",
					width: "160"
				},
				{
					prop: "commissionUserName",
					label: "提成员工",
					align: "center",
					width: "100"
				},
				{
					prop: "commissionMoney",
					label: "提成金额",
					align: "center",
					width: "100",
					isMoney: true,
					moneyType: "normal"
				},
				{
					prop: "creator",
					label: "创建人",
					align: "center",
					width: "80"
				},
				{
					prop: "editor",
					label: "维护人",
					align: "center",
					width: "80"
				},
				{
					prop: "updateTime",
					label: "维护时间",
					align: "center",
					width: "160"
				},
				{
					slot: "operation",
					label: "操作",
					align: "center",
					width: "180",
					fixed: "right"
				}
			],
			customerTypeList: [],
			btnPermissionList: {
				commission: false
			},
			// 提成
			commissionShow: false,
			employeeList: [],
			commissionGrant: {
				keyId: "",
				commissionUserKeyId: "",
				type: 1
			},
			inStoreTypeList: []
		};
	},
	// 注册组件
	components: {
		edit,
		selectOrderPage
	},
	created() {
		this.GetOrgInfoListByConfig();
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.getListData();
		this.GetEnumConfigListByCode();
		this.getBtnPermissionList();
		this.GetUserBindSelectByPermission();
		this.GetInStoreTypeList();
	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		// 获取按钮权限
		getBtnPermissionList() {
			this.btnPermissionList.commission = this.$checkBtnPermission("/customer/index", "commission");
		},
		// 性别
		formatterFre(gender) {
			return gender == 1 ? "男" : gender == 0 ? "女" : "";
		},
		changePages() {},
		handleCommand(command) {
			// 1编辑
			switch (command.command) {
				case "4":
					this.deleteCustomer(command.rowData);
					break;
				default:
					console.log(command);
			}
		},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						res.data.forEach((item) => {
							this.storeList.push({
								keyId: item.keyId,
								value: item.name + "【" + item.remark2 + "】"
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		// 获取顾客类型
		GetEnumConfigListByCode() {
			const paramer = {
				code: "CustomerType"
			};
			GetEnumConfigListByCode(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.customerTypeList = [];
						res.data.forEach((item) => {
							this.customerTypeList.push({
								keyId: parseInt(item.code),
								value: item.name
							});
						});
						this.customerTypeList.unshift({
							keyId: 0,
							value: "全部"
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取顾客类型信息失败!");
				});
		},
		// 单击行数据
		handleRowClick(row) {
			this.$refs.edit.editShow(row);
		},
		//显示编辑界面
		handleEdit(row) {
			this.$refs.edit.editShow(row);
		},
		// 删除
		deleteCustomer(row) {
			this.$confirm("确定要删除顾客【" + row.name + "】吗?", "信息", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				let parmter = {
					keyId: row.keyId
				};
				deleteCustomerInfo(parmter)
					.then((res) => {
						if (res.code === 1) {
							this.$message({
								type: "success",
								message: "已删除!"
							});
							this.getListData();
						} else {
							this.$message({
								type: "info",
								message: res.msg
							});
						}
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error("删除失败，请稍后再试！");
					});
			});
		},
		// 获取列表
		getListData() {
			this.loading = true;
			getCustomerInfoPageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.search();
		},
		inputChange(val) {
			this.search();
		},
		// 提成时间范围变更（清空时 val 为 null）
		setGrantTimeRange(val) {
			this.$set(this.formInline, "grantTimeStart", val && val.length === 2 ? val[0] : null);
			this.$set(this.formInline, "grantTimeEnd", val && val.length === 2 ? val[1] : null);
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
				this.pageparm.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
				this.pageparm.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.pageparm.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		// 提成
		handleCommissionClick(row) {
			this.commissionShow = true;
			this.commissionGrant = {
				keyId: row.keyId,
				type: 1,
				commissionUserKeyId: ""
			};
			this.GetUserBindSelectByPermission(row.belongStoreKeyId);
		},
		// 确认提成
		handleGrantCommissionClick() {
			if (this.commissionGrant.commissionUserKeyId == "") {
				this.$message.error("请选择提成员工");
				return;
			}
			this.$confirm("确定提成给选中的员工吗?\n", "信息(一经给出，无法撤回)", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				this.loading = true;
				GrantVipCommission(this.commissionGrant)
					.then((res) => {
						if (res.code === 1) {
							this.$message({
								type: "success",
								message: "提成设置成功!"
							});
							this.commissionShow = false;
							this.getListData();
						} else {
							this.$message({
								type: "info",
								message: res.msg
							});
						}
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error("提成设置失败，请稍后再试！");
					})
					.finally(() => {
						this.loading = false;
					});
			});
		},
		// 获取人员信息绑定下拉框_根据权限
		GetUserBindSelectByPermission(val) {
			const paramer = {
				keyId: val
			};
			GetUserBindSelectByPermission(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.employeeList = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取人员信息失败!");
				});
		},
		// 选择订单
		handleSelectOrderPage(row) {
			this.$refs.selectOrderPage.showSelectOrderDialog(row.keyId);
		},
		// 获取进店类型
		GetInStoreTypeList() {
			const paramer = {
				code: "InStoreType"
			};
			GetEnumConfigListByCode(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.inStoreTypeList = [];
						res.data.forEach((item) => {
							this.inStoreTypeList.push({
								keyId: parseInt(item.code),
								value: item.name
							});
						});
						this.inStoreTypeList.unshift({
							keyId: 0,
							value: "全部"
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取进店类型信息失败!");
				});
		}
	}
};
</script>

<style scoped>
::v-deep(.customer-commission-dialog) {
	border-radius: 12px;
	overflow: hidden;
}

::v-deep(.customer-commission-dialog .el-dialog__body) {
	padding: 18px 20px !important;
}

::v-deep(.customer-commission-dialog .el-dialog__footer) {
	padding: 14px 20px 18px;
	border-top: 1px solid var(--app-border);
}

::v-deep .el-link--primary {
	color: var(--app-primary-text);
}

::v-deep .el-link--primary:hover {
	color: var(--app-primary-text);
	text-decoration: underline;
	text-underline-offset: 3px;
}

/* 「是否办卡」是/否：不是性别，单独用语义类，避免与 .one_1/.one_2 性别色混淆 */
.yes-no {
	display: inline-block;
	padding: 2px 12px;
	border-radius: var(--app-radius-sm);
	border: 1px solid transparent;
	white-space: nowrap;
	line-height: 1.6;
}

.yes-no--yes {
	background: var(--app-success-soft);
	border-color: var(--app-success-border);
	color: var(--app-success-text);
}

.yes-no--no {
	background: var(--app-surface-sunken);
	border-color: var(--app-border-strong);
	color: var(--app-text-secondary);
}
</style>
